module.exports = __webpack_public_path__ + "e6f05fb3109ffd9e819bed0dd59d2680.svg";